/**
 * Validates if the minimum order amount meets Mexico's Stripe restriction
 * Minimum is MXN 100 per installment
 */
export const hasMinOrderAmountErrorMx = (
  value: number,
  quantity: number,
): boolean => {
  if (value <= 0) return false;

  const minimumRequired = 100 * quantity;
  return value < minimumRequired;
};

export const getMinOrderAmountMx = (quantity: number): number => {
  return 100 * quantity;
};
